var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('div',{staticClass:"text-h6 text-center"},[_c('span',[_vm._v("Wir leiten Sie weiter zu PayPal")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }